
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_1ac3b_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_1ac3b_96",
  "sticky-background": "awsui_sticky-background_hyvsj_1ac3b_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_1ac3b_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1ac3b_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_1ac3b_133",
  "drawers-container": "awsui_drawers-container_hyvsj_1ac3b_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_1ac3b_157",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_1ac3b_191",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_1ac3b_196",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_1ac3b_214",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_1ac3b_246",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_1ac3b_246",
  "drawer": "awsui_drawer_hyvsj_1ac3b_145",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_1ac3b_297",
  "drawer-content": "awsui_drawer-content_hyvsj_1ac3b_302",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_1ac3b_307",
  "content": "awsui_content_hyvsj_1ac3b_341",
  "layout": "awsui_layout_hyvsj_1ac3b_362",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_1ac3b_445",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_1ac3b_460",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_1ac3b_477",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_1ac3b_509",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_1ac3b_512",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_1ac3b_522",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_1ac3b_525",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_1ac3b_528",
  "has-header": "awsui_has-header_hyvsj_1ac3b_528",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_1ac3b_549",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_1ac3b_549",
  "has-split-panel": "awsui_has-split-panel_hyvsj_1ac3b_592",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_1ac3b_592",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1ac3b_608",
  "unfocusable": "awsui_unfocusable_hyvsj_1ac3b_613",
  "container": "awsui_container_hyvsj_1ac3b_623",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_1ac3b_648",
  "is-tools-open": "awsui_is-tools-open_hyvsj_1ac3b_651",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_1ac3b_651",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_1ac3b_651",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_1ac3b_660",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_1ac3b_676",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_1ac3b_680",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_1ac3b_684",
  "navigation-container": "awsui_navigation-container_hyvsj_1ac3b_693",
  "show-navigation": "awsui_show-navigation_hyvsj_1ac3b_737",
  "animating": "awsui_animating_hyvsj_1ac3b_759",
  "showButtons": "awsui_showButtons_hyvsj_1ac3b_1",
  "navigation": "awsui_navigation_hyvsj_1ac3b_693",
  "openNavigation": "awsui_openNavigation_hyvsj_1ac3b_1",
  "animated-content": "awsui_animated-content_hyvsj_1ac3b_820",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1ac3b_829",
  "notifications": "awsui_notifications_hyvsj_1ac3b_839",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_1ac3b_845",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1ac3b_862",
  "position-bottom": "awsui_position-bottom_hyvsj_1ac3b_908",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1ac3b_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1ac3b_937",
  "position-side": "awsui_position-side_hyvsj_1ac3b_965",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_1ac3b_1",
  "tools-container": "awsui_tools-container_hyvsj_1ac3b_1002",
  "tools": "awsui_tools_hyvsj_1ac3b_1002",
  "openTools": "awsui_openTools_hyvsj_1ac3b_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_1ac3b_1096",
  "hide-tools": "awsui_hide-tools_hyvsj_1ac3b_1106",
  "show-tools": "awsui_show-tools_hyvsj_1ac3b_1118",
  "has-tools-form": "awsui_has-tools-form_hyvsj_1ac3b_1096",
  "trigger": "awsui_trigger_hyvsj_1ac3b_1185",
  "selected": "awsui_selected_hyvsj_1ac3b_1224"
};
  